module.exports = __webpack_public_path__ + "img/goldregen-2020-112.f7fb44be.jpg";